var _a, _b, _c, _d, _e, _f, _g, _h;
import { __decorate, __metadata } from "tslib";
import fornecService from "@/core/services/fornecService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Orgao_EmissorActions } from "@/store/enums/FornecEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Orgao_EmissorModule = class Orgao_EmissorModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Orgao_EmissorActions.POST_ORGAO_EMISSOR](data) {
        return new Promise(resolve => {
            fornecService.post("Orgao_Emissor/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_b = Orgao_EmissorActions.PUT_ORGAO_EMISSOR](data) {
        return new Promise(resolve => {
            fornecService.put("Orgao_Emissor/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_c = Orgao_EmissorActions.DELETE_ORGAO_EMISSOR](data) {
        return new Promise(resolve => {
            fornecService.delete("Orgao_Emissor/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Orgao_EmissorActions.DELETE_RANGE_ORGAO_EMISSOR](data) {
        return new Promise(resolve => {
            fornecService.delete("Orgao_Emissor/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Orgao_EmissorActions.FILTER_ORGAO_EMISSOR](data) {
        return new Promise(resolve => {
            fornecService.post("Orgao_Emissor/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Orgao_EmissorActions.GET_ORGAO_EMISSOR]() {
        return new Promise(resolve => {
            fornecService.get("Orgao_Emissor/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Orgao_EmissorActions.GETWITHDISABLED_ORGAO_EMISSOR]() {
        return new Promise(resolve => {
            fornecService.get("Orgao_Emissor/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Orgao_EmissorActions.GET_BY_ID_ORGAO_EMISSOR](data) {
        return new Promise(resolve => {
            fornecService.get("Orgao_Emissor/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Orgao_EmissorModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Orgao_EmissorModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Orgao_EmissorModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Orgao_EmissorModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Orgao_EmissorModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Orgao_EmissorModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Orgao_EmissorModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Orgao_EmissorModule.prototype, _h, null);
Orgao_EmissorModule = __decorate([
    Module
], Orgao_EmissorModule);
export default Orgao_EmissorModule;
//# sourceMappingURL=Orgao_EmissorModule.js.map